import { useAppDisplayModeContext } from '@archipro-design/aria';
import { MainInfoRightSectionItem } from './MainInfoRightSectionItem';

import type { OverviewLoaderData } from '@modules/professional/page/OverviewPage';
import { useLoaderData } from '@remix-run/react';
import InfoSectionMobile from '~/modules/detail/components/info-section/InfoSectionMobile';

export const YearJoined: React.FC = () => {
    const { professionalOverview } = useLoaderData<OverviewLoaderData>();
    const { mobile } = useAppDisplayModeContext();
    const yearJoined = professionalOverview?.ProfileLiveDate?.substring(0, 4);
    if (!yearJoined) {
        return null;
    }

    return mobile ? (
        <InfoSectionMobile label="ArchiPro Member since">
            {yearJoined}
        </InfoSectionMobile>
    ) : (
        <MainInfoRightSectionItem label="ArchiPro Member since">
            {yearJoined}
        </MainInfoRightSectionItem>
    );
};
